<template>
  <div>
    <AnggotaPartial :key="$route.params.id" @onStatusDetail="onStatusDetail">
      <template #from-anggota-baru>
        <b-row v-if="statusDetail == STATUS_VERIFIKASI_ANGGOTA.PENDING && IS_HAVE_PERMISSION_APPROVAL">
          <b-col cols="12" md="6">
            <b-form-group label="Keterangan" description="Wajib diisi bila menyatakan 'Yakin Salah'">
              <b-form-textarea v-model="form.notes" placeholder="Contoh: Salah ketik..." rows="4"
                maxlength="100"></b-form-textarea>
            </b-form-group>
            <div class="d-flex gap-2">
              <b-button variant="success" @click="showModalYakinBenar">Yakin Benar</b-button>
              <b-button variant="danger" @click="showModalYakinSalah">Yakin Salah</b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </AnggotaPartial>

    <ModalConfirm id="modal-confirm-yakin-benar" title="Confirm Yakin Benar" :isSubmitting="isSubmitting" desc="Apakah anda yakin data anggota ini benar?" @submit="onApproval(STATUS_VERIFIKASI_ANGGOTA.VERIFIED)" />
    <ModalConfirm id="modal-confirm-yakin-salah" title="Confirm Yakin Salah" :isSubmitting="isSubmitting" desc="Apakah anda yakin data anggota ini salah?" @submit="onApproval(STATUS_VERIFIKASI_ANGGOTA.REJECTED)" />
    <b-modal id="modal-next-work" title="Konfirmasi Langkah Selanjutnya" centered no-close-on-backdrop no-close-on-esc hide-header-close>
      <p class="mb-0">Apakah Anda ingin melanjutkan kerja atau menyelesaikan pekerjaan?</p>

      <template v-slot:modal-footer="{}">
        <b-button variant="secondary" @click="onDoneWork" :disabled="isNextWork">Selesai Kerja {{ isNextWork ? '...' : '' }}</b-button>
        <b-button variant="primary" @click="onNextWork" :disabled="isNextWork">Lanjut Kerja {{ isNextWork ? '...' : '' }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AnggotaPartial from './AnggotaPartial.vue'
import CONSTANTS from '@/constants'
  
export default {
  components: {
    AnggotaPartial
  },
  data() {
    return {
      form: {
        notes: ''
      },
      isSubmitting: false,
      isNextWork: false,
      statusDetail: false,
    }
  },
  computed: {
    STATUS_VERIFIKASI_ANGGOTA() {
      return CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA
    },
    IS_HAVE_PERMISSION_APPROVAL() {
      return this.$helper.hasPermissionMenuChildren('VNN')
    },
  },
  methods: {
    showModalYakinBenar() {
      this.$bvModal.show("modal-confirm-yakin-benar")
    },
    showModalYakinSalah() {
      this.$bvModal.show("modal-confirm-yakin-salah")
    },
    onApproval(status) {
      if (status == this.STATUS_VERIFIKASI_ANGGOTA.REJECTED && this.$helper.isNullOrEmpty(this.form.notes)) {
        this.$helper.toastErr(this, "Mohon isi keterangan terlebih dahulu")
        return;
      }

      this.isSubmitting = true;

      const params = {
        nasabahId: this.$route.params.id,
        note: this.form.notes,
        status: status,
      }

      this.$axios.post('nasabah/verifikasi-update-status', {}, { params })
      .then(response => {
          this.$helper.toastSucc(this, response.data.name)
          this.$bvModal.hide('modal-confirm-yakin-benar')
          this.$bvModal.hide('modal-confirm-yakin-salah')
          this.$bvModal.show('modal-next-work')
      })
      .catch(error => {
          this.$helper.parseError(this, error)
      })
      .finally(() => {
          this.isSubmitting = false;
      })
    },
    onStatusDetail(value) {
      this.statusDetail = value
    },
    onDoneWork() {
      this.$router.push({ path: '/persetujuan/anggota-baru' })
    },
    onNextWork() {
      this.isNextWork = true;
      this.$axios.post('nasabah/find-for-verify').then(response => {
        const id = response.data.id;
        this.$bvModal.hide('modal-next-work')
        if (id) {
          this.$router.push(`/persetujuan/anggota-baru/${response.data.id}`)
          this.form.notes = ''
        } else {
          this.$router.push({
            path: '/persetujuan/anggota-baru',
            query: { doneWork: true }
          })
        }
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isNextWork = false;
      })
    },
  },
}
</script>